import type { ComponentProps } from 'react'
import { FiCheck } from 'react-icons/fi'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import {
  SsrDataProvider,
  type SsrPageData,
} from '@presentation/ssr/SsrDataContext'

interface AppRootProps {
  router: ComponentProps<typeof RouterProvider>['router']
  ssrData?: SsrPageData | null
}

export default function AppRoot({
  router,
  ssrData = null,
}: AppRootProps) {
  return (
    <SsrDataProvider value={ssrData}>
      <RouterProvider router={router} />
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2000,
          classNames: {
            toast: 'rounded-xl border border-border-light bg-background px-4 py-3 font-body text-text-primary shadow-lg',
            title: 'text-base font-semibold text-text-primary',
            error: 'text-text-primary',
            success: 'text-text-primary',
          },
        }}
        icons={{
          success: <FiCheck className="h-5 w-5 text-green" />,
        }}
      />
    </SsrDataProvider>
  )
}
